import angular from 'angular';

import GeneratorMixpanelService from './generator_mixpanel.service';

angular.module('generator.analytics', ['generator.shared']);

angular
  .module('generator.analytics')
  .factory('GeneratorMixpanelService', GeneratorMixpanelService);
